import React, { FC } from 'react';
import { Box, Text } from '@bechtel/gds';
import { TextWithEllipsis } from '@bechtel/client-common';
import { t } from '@lingui/macro';
import { EllipseStyled } from './styled';
import { RodRequestWeld, RodRequestWeldStatus } from '@bechtel/types';

interface WeldItemProps {
  rodRequestWeld: RodRequestWeld;
}

export const WeldItem: FC<WeldItemProps> = ({ rodRequestWeld }) => {
  const { weld, status } = rodRequestWeld;
  return (
    <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-between' }} flexGrow={{ sm: 1 }}>
      <Box flexDirection={{ sm: 'column' }} css={{ maxWidth: '100%' }}>
        <Box alignItems={{ sm: 'center' }}>
          <TextWithEllipsis
            data-testid="weld-tag"
            family="graphikCompact"
            size="00"
            color="grey.1000"
            weight="600"
            transform="uppercase"
          >
            {weld.tag}
          </TextWithEllipsis>
        </Box>

        <Box mb={{ sm: '200' }} mt={{ sm: '300' }} alignItems={{ sm: 'center' }}>
          {weld.pipeMaterial && (
            <Box data-testid="weld-pipe-material" mr={{ sm: '300' }}>
              <Text size="200" color="grey.700">
                {weld.pipeMaterial}
              </Text>
            </Box>
          )}         
          {weld.pipeDiameter && (
            <>
              <EllipseStyled mx={{ sm: '400' }} />
              <Text data-testid="weld-pipe-diameter" size="300" color="grey.700">
                {`${weld.pipeDiameter}${t`" Diameter`}`}
                &nbsp;
              </Text>
            </>
          )}
        </Box>
      </Box>
      <Box>
        <Text size="300" color="grey.700" weight="400">
          {status === RodRequestWeldStatus.COMPLETED ? t`Complete` : t`Not Complete`}
        </Text>
      </Box>
    </Box>
  );
};
